import kalapostAPI, { getErrorType } from "./httpService";

export const getPaySerivece = async (trackingNumber) => {
   try {
      return await kalapostAPI.get("payService", {
         params: { trackingNumber },
      });
   } catch (error) {
      return getErrorType(error);
   }
};